import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "change-hold-checkbox"
}

import Api from "@/services/api/ApiServiceFabrick";
import { ref } from 'vue';
import i18n from '@/lang/i18n';
import CvrUpload from "@/types/CvrUpload";
import ConfirmationModal from "@/components/Common/ConfirmationModal.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ChangeHoldSwitch',
  props: {
    item: {},
    reload: { type: Function },
    showFlash: { type: Function },
    updateAuthority: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const requesting = ref(false);

const confirmationModalTitle = ref("")
const confirmationModalState = ref(false)

function showAlert(error: any) {
  const firstError = (error?.response?.data?.errors?.hold ?? [])[0] ?? '';
  if (firstError == i18n.global.t('pages.cvr_uploads.holdMessages.numberOfHoldingIsOverThresholdDetail')){
    props.showFlash(
      i18n.global.t('pages.cvr_uploads.holdMessages.numberOfHoldingIsOverThreshold'),
      "error",
      false
    );
    return;
  }

  console.log(error)
  props.showFlash(
    i18n.global.t('common.unknownErrorMessage'),
    "error",
    false
  );
}

function showNotification() {
  props.showFlash(
    i18n.global.t('pages.cvr_uploads.holdMessages.successHold'),
    "success",
    true
  );
}

const closeConfirmation = () => {
  hold.value = true;
  confirmationModalState.value = false;
  confirmationModalTitle.value = "";
}

const hold = ref(props?.item?.hold ?? false);

function isVisible() {
  return (props?.item?.status ?? '').toLowerCase() == 'complete' &&
    props?.item?.request_type == 'request';
}

function handleHold(elem) {
  if (hold.value) {
    setHold()
  } else {
    confirmationModalState.value = true;
    confirmationModalTitle.value = i18n.global.t('pages.cvr_uploads.holdMessages.confirmationModalTitle');
  }
}

async function removeHold() {
  requesting.value = true;
  const res = await Api().updateCvrUploadHold(props.item.id, false).catch((error) => {
    console.log(error);
  });
  if (res) {
    props.showFlash(
      i18n.global.t('pages.cvr_uploads.holdMessages.successIgnoreHold'),
      "success",
      true
    );
    props.reload();
  }
  requesting.value = false;
  confirmationModalState.value = false;
}

async function setHold() {
  requesting.value = true;
  const res = await Api().updateCvrUploadHold(props.item.id, true).catch((error) => {
    hold.value = false;
    showAlert(error);
  });
  if (res?.hold === true) showNotification();
  if (res) props.reload();
  requesting.value = false;
}


return (_ctx: any,_cache: any) => {
  const _component_v_switch = _resolveComponent("v-switch")!

  return (isVisible())
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_v_switch, {
          class: "toggle-switch",
          modelValue: hold.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((hold).value = $event)),
          onChange: handleHold,
          readonly: requesting.value,
          color: "success",
          "hide-details": "",
          disabled: !props.updateAuthority
        }, null, 8, ["modelValue", "readonly", "disabled"]),
        _createVNode(ConfirmationModal, {
          title: confirmationModalTitle.value,
          titleClass: "change-hold-checkbox-modal-confirmation-title",
          modalState: confirmationModalState.value,
          confirmBtnName: _unref(i18n).global.t('pages.cvr_uploads.holdMessages.confirmationModalBtnLabel'),
          modalMaxWidth: "40%",
          onConfirm: removeHold,
          onCancel: closeConfirmation,
          loading: requesting.value
        }, null, 8, ["title", "modalState", "confirmBtnName", "loading"])
      ]))
    : _createCommentVNode("", true)
}
}

})